<template>
  <div class="upgradeGroupSchool">
    <module-title title="升级分组学校">
      <div class="right">
        <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="$emit('back')">
          返回
        </el-button>
      </div>
    </module-title>
    <div class="upgradeGroupSchool-main">
      <div class="upgradeGroupSchool-main-left">
        <el-input
          v-model="filterText"
          class="input"
          placeholder="输入关键字进行过滤"
        />
        <el-tree
          ref="tree"
          class="filter-tree"
          show-checkbox
          :data="orgTreeData"
          :props="defaultProps"
          :default-expanded-keys="checkKeys"
          node-key="code"
          :filter-node-method="filterNode"
          @check-change="handleCheckChange"
        />
      </div>
      <div class="upgradeGroupSchool-main-right">
        <el-input
          v-model="searchForm.name"
          class="input"
          name="name"
          placeholder="请输入组名"
          :maxlength="22"
          @input="(val)=>{
            if(val.length>20){
              $message({
                message: '请输入20以内的字符',
                type: 'error'
              });
              return false;
            }
          }"
        />
        <div class="scholls">
          <span v-for="item in checkData" :key="item.code" class="scholl"><i class="el-icon-delete" @click="deleteApplication(item.code)" />&nbsp;&nbsp;{{ item.name }}</span>
        </div>
      </div>
    </div>
    <div class="footer">
      <el-button
        size="medium"
        class="btn"
        @click="$emit('back')"
      >
        取消
      </el-button>
      <el-button
        type="primary"
        size="medium"
        class="btn"
        @click="handleGruopSchool"
      >
        确定
      </el-button>
    </div>
  </div>
</template>
<script>
import { getOrgTree } from '@/api/systemMaintenance/devicManage/common';
import { campusAppAddGroups, campusAppUpdateGroups, campusAppSchoolGroup } from '@/api/systemManage/softwareUpdate';

export default {
  name: 'UpgradeGroupSchool',
  props: {
    id: {
      type: String,
      default: ''
    },
    campusAppId: {
      type: String,
      default: ''
    },
    typeCode: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      defaultProps: {
        children: 'childOrgList',
        label: 'name'
      },
      searchForm: { name: '' },
      filterText: '',
      orgTreeData: [],
      checkKeys: [],
      checkData: []
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  mounted() {
    if (this.id) this.getGroup();
    this.fetchOrgTree();
  },
  methods: {
    getGroup() {
      campusAppSchoolGroup(this.id, { typeCode: this.typeCode })
        .then((result) => {
          this.searchForm.name = result.data.name;
          this.checkKeys = result.data.schools.map(item => item.schoolCode);
          this.checkData = result.data.schools.map(item => {
            return { code: item.schoolCode, name: item.name };
          });
          // this.checkKeys = ['ORG666777', 'ORG000005'];
          // this.checkData = [{ code: 'ORG666777', name: '测试教程学校' }, { code: 'ORG000005', name: '雨花区阳光小学' }];
          this.$refs.tree.setCheckedKeys(this.checkKeys);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 根据机构code获取机构树
    fetchOrgTree() {
      getOrgTree()
        .then(res => {
          this.orgTreeData = res.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleCheckChange(data, checked, indeterminate) {
      if (checked && (!data.childOrgList || data.childOrgList.length === 0)) {
        if (this.checkKeys.findIndex(item => item === data.code) === -1) {
          this.checkKeys.push(data.code);
          this.checkData.push({ code: data.code, name: data.name });
        }
      } else if (!checked && this.checkKeys.findIndex(item => item === data.code) !== -1) {
        this.$refs.tree.setCheckedKeys(this.checkKeys);
        this.$message.error('该学校已添加!');
      }
    },
    deleteApplication(code) {
      this.checkKeys = this.checkKeys.filter(item => item !== code);
      this.checkData = this.checkData.filter(item => item.code !== code);
      this.$refs.tree.setCheckedKeys(this.checkKeys);
    },
    handleGruopSchool() {
      if (this.checkKeys.length === 0) {
        this.$message({
          type: 'warning',
          message: '未选中学校！'
        });
        return;
      }
      var params = { campusAppId: this.campusAppId, typeCode: this.typeCode, name: this.searchForm.name };
      params.schoolGroupRelations = this.checkKeys.map(item => {
        return { schoolCode: item };
      });
      if (this.id) {
        campusAppUpdateGroups(this.id, params)
          .then((result) => {
            this.$notify.success({
              title: 'Success',
              message: '编辑成功',
              showClose: false,
              duration: 2000
            });
            this.$emit('back');
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        campusAppAddGroups(params)
          .then((result) => {
            this.$notify.success({
              title: 'Success',
              message: '添加成功',
              showClose: false,
              duration: 2000
            });
            this.$emit('back');
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  }
};
</script>
<style scoped lang="scss">
  .upgradeGroupSchool{
    .upgradeGroupSchool-main{
        padding: 10px 50px;
        display: flex;
        .input{
            display: inline-block;
        }
        &-left{
          padding: 10px;
          width: 260px;
          margin-right: 50px;
          display: inline-block;
          border: 1px solid #DCDFE6;
          .filter-tree{
              margin-top: 10px;
          }
        }
        &-right{
            display: inline-block;
            width: 260px;
            vertical-align: top;
            display: flex;
            flex-direction: column;
            .scholls{
                margin-top: 10px;
                padding-top: 10px;
                border: 1px solid #DCDFE6;
                padding-left: 10px;
                flex: 1;
            }
            .scholl{
                display: block;
                line-height: 30px;
                font-size: 14px;
                color: #606266;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .el-icon-delete{
                color: #409EFF;
            }
        }
    }
    .footer{
      margin: 40px 0 20px 50px;
      width: 570px;
      text-align: center;
      .btn{
        margin: 0 40px;
      }
    }
  }
</style>
<style lang="scss">
.upgradeGroupSchool{
  .el-tree .el-tree-node .is-leaf + .el-checkbox .el-checkbox__inner{display: inline-block;}
  .el-tree .el-tree-node .el-checkbox .el-checkbox__inner{display: none;}
  .el-tree .el-tree-node .el-tree-node__content .el-tree-node__label{
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
